"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localStorage = void 0;
exports.localStorage = {
    getDebugConfig: () => typeof window !== "undefined"
        ? window.localStorage.getItem("debug")
        : undefined,
};
